import api from 'modules/api/index';

export const addCallStatusRequest = (payload) => {
  return api.post('/call-status', payload);
};

export const updateCallStatusRequest = ({ id, status }) => {
  return api.patch('/call-status', { id, status });
};
